import { createFileRoute } from '@tanstack/react-router';
import { ResultadoPortal } from './resultado';

export const Route = createFileRoute('/pep-vida/resultado/$protocolo/$cdPaciente')({
  component: ResultadoPortal,
});
